<template>
  <div class="blog-area ptb-100">
    <div class="container mw-1356">
      <div class="section-title m-auto text-center mw-860">
        <span class="top-title">المدونة</span>
        <h2>أحدث مقالاتنا حول عالم الـ IPTV</h2>
      </div>

      <div class="row">
        <div class="col-lg-9 order-2 order-lg-1">
          <div class="row justify-content-center">
            <div
              v-for="blog in paginatedBlogs"
              :key="blog.id"
              class="col-xl-4 col-md-6"
            >
              <div class="blog-single-item transition-y">
                <RouterLink
                  :to="`/blog-details/${blog.id}`"
                  class="d-block blog-img"
                >
                  <img :src="blog.image" :alt="blog.title" />
                </RouterLink>

                <div class="blog-content">
                  <RouterLink to="/blog" class="tag">
                    {{ blog.category }}
                  </RouterLink>

                  <h3>
                    <RouterLink :to="`/blog-details/${blog.id}`">
                      {{ blog.title }}
                    </RouterLink>
                  </h3>

                  <ul class="d-flex align-items-center flex-wrap ps-0 mb-0">
                    <li class="d-flex align-items-center">
                      <i class="ti ti-calendar-week"></i>
                      <span>{{ blog.date }}</span>
                    </li>
                    <li class="d-flex align-items-center">
                      <i class="ti ti-clock"></i>
                      <span>{{ blog.readTime }} دقيقة قراءة</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-lg-12">
              <div class="pagination-area text-center mt-4">
                <span
                  class="next page-numbers"
                  :class="{ disabled: currentPage === 1 }"
                  @click="prevPage"
                >
                  <i class="ri-arrow-left-s-line"></i>
                </span>

                <span
                  v-for="page in totalPages"
                  :key="page"
                  class="page-numbers"
                  :class="{ current: currentPage === page }"
                  @click="goToPage(page)"
                >
                  {{ page }}
                </span>

                <span
                  class="next page-numbers"
                  :class="{ disabled: currentPage === totalPages }"
                  @click="nextPage"
                >
                  <i class="ri-arrow-right-s-line"></i>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-3 order-1 order-lg-2 mb-5 mb-lg-0">
          <SidebarWidget />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from "vue";
import { useHead } from "@unhead/vue";
import SidebarWidget from "./SidebarWidget.vue";

export default defineComponent({
  name: "BlogSection",
  components: { SidebarWidget },
  setup() {
    useHead({
      title: "مدونة IPTV | شروحات ونصائح وأحدث المقالات",
      meta: [
        {
          name: "description",
          content:
            "اكتشف أحدث المقالات والشروحات حول IPTV، أفضل المشغلات، حلول التقطيع، القنوات العربية، جودة 4K، وأهم النصائح للحصول على أفضل تجربة مشاهدة.",
        },
        {
          name: "keywords",
          content:
            "مدونة IPTV, مقالات IPTV, شروحات IPTV, قنوات عربية, IPTV 4K, IPTV HD, أفضل مشغل IPTV, حلول IPTV",
        },
        {
          property: "og:title",
          content: "مدونة IPTV | شروحات ونصائح وأحدث المقالات",
        },
        {
          property: "og:description",
          content:
            "تابع أحدث المقالات والشروحات المتعلقة بخدمات IPTV والأجهزة والقنوات وأفضل النصائح التقنية.",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "robots",
          content: "index, follow",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://karamtv4k.com/blog",
        },
      ],
    });

    const blogs = ref([
      {
        id: 1,
        image: require("@/assets/images/blog-4.jpg"),
        category: "تقنية IPTV",
        title: "كيف تضبط إعدادات سيرفر الـ IPTV للحصول على أعلى ثبات؟",
        date: "23 يناير، 2026",
        readTime: 5,
      },
      {
        id: 2,
        image: require("@/assets/images/blog-2.jpg"),
        category: "نصائح",
        title: "أفضل مشغلات IPTV لأجهزة أندرويد وشاشات سمارت",
        date: "22 يناير، 2026",
        readTime: 4,
      },
      {
        id: 3,
        image: require("@/assets/images/blog-3.jpg"),
        category: "شروحات",
        title: "دليلك الشامل لتركيب Fire TV Stick مع اشتراكك",
        date: "21 يناير، 2026",
        readTime: 6,
      },
      {
        id: 4,
        image: require("@/assets/images/blog-5.jpg"),
        category: "مجتمع",
        title: "لماذا يفضل المحترفون اشتراكات IPTV الخاصة بنا؟",
        date: "20 يناير، 2026",
        readTime: 3,
      },
      {
        id: 5,
        image: require("@/assets/images/blog-6.jpg"),
        category: "تقنية",
        title: "حل مشاكل التقطيع أثناء مباريات كرة القدم المباشرة",
        date: "19 يناير، 2026",
        readTime: 5,
      },
      {
        id: 6,
        image: require("@/assets/images/blog-7.jpg"),
        category: "معرفة",
        title: "فهم جودة 4K و الفرق بينها وبين Full HD في البث",
        date: "18 يناير، 2026",
        readTime: 4,
      },
      {
        id: 7,
        image: require("@/assets/images/blog-8.jpg"),
        category: "نصائح",
        title: "كيف تحمي خصوصيتك عند استخدام خدمات البث",
        date: "17 يناير، 2026",
        readTime: 4,
      },
      {
        id: 8,
        image: require("@/assets/images/blog-9.jpg"),
        category: "دعم",
        title: "خطوات تفعيل اشتراكك في أقل من دقيقة",
        date: "16 يناير، 2026",
        readTime: 2,
      },
      {
        id: 9,
        image: require("@/assets/images/blog-10.jpg"),
        category: "تقنية",
        title: "أهم الميزات المخفية في تطبيق IPTV الخاص بنا",
        date: "15 يناير، 2026",
        readTime: 5,
      },
    ]);

    const currentPage = ref(1);
    const itemsPerPage = ref(9);

    const totalPages = computed(() =>
      Math.ceil(blogs.value.length / itemsPerPage.value)
    );

    const paginatedBlogs = computed(() => {
      const start = (currentPage.value - 1) * itemsPerPage.value;
      return blogs.value.slice(start, start + itemsPerPage.value);
    });

    const goToPage = (page: number) => {
      currentPage.value = page;
    };

    const nextPage = () => {
      if (currentPage.value < totalPages.value) {
        currentPage.value++;
      }
    };

    const prevPage = () => {
      if (currentPage.value > 1) {
        currentPage.value--;
      }
    };

    return {
      paginatedBlogs,
      currentPage,
      totalPages,
      goToPage,
      nextPage,
      prevPage,
    };
  },
});
</script>